import React, { memo } from 'react';
import { IconButton, CircularProgress, Box } from '@mui/material';
import { nqiStyles, colorFor, iconFor } from './style';
import { Quality } from '../../../commands/practitioner/enums/CallQuality';
import Tooltip from '../../Tooltip/Tooltip';

export interface NetworkQualityIndicatorProps {
  quality: Quality;
  title?: React.ReactNode;
  onClick?: () => void;
  size?: 'small' | 'medium' | 'large';
  disabled: boolean;
  className?: string;
}

const NetworkQualityIndicator: React.FC<NetworkQualityIndicatorProps> = (props: NetworkQualityIndicatorProps) => {
  const { title, onClick, disabled, className, quality, size } = props;
  const isTesting = quality === 'testing';
  const ariaLabel = typeof title === 'string' ? title : undefined;

  return (
    <Tooltip placement="bottom-end" title={title}>
      <Box component="span" sx={{ display: 'inline-flex' }}>
        <IconButton
          type="button"
          aria-label={ariaLabel}
          onClick={onClick}
          disabled={disabled}
          className={className}
          sx={nqiStyles.button(quality, size)}
        >
          {isTesting ? (
            <CircularProgress size={18} thickness={5} sx={nqiStyles.spinner} />
          ) : (
            <Box className="nqi-icon" sx={nqiStyles.icon(colorFor(quality), iconFor(quality), size)} />
          )}
        </IconButton>
      </Box>
    </Tooltip>
  );
};

export default memo(NetworkQualityIndicator);
